// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/orographic-lift.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/orographic-lift/orographic-lift.js';

mount([g0]);
